import { debounce } from 'lodash';
import { useEffect, useMemo } from 'react';

function useDebouncedCallback<TArgs extends Array<unknown>, TReturn>(
  callback: (...args: TArgs) => TReturn,
  time = 300,
) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedCallback = useMemo(() => debounce(callback, time), [time]);

  useEffect(() => {
    return () => {
      debouncedCallback.cancel();
    };
  }, [debouncedCallback]);

  return debouncedCallback;
}

export default useDebouncedCallback;
